import PropTypes from 'prop-types';
import React, { Component } from 'react';

import { SR_API_ACTION_UPDATE_USER } from 'api/actionTypes';

import { formatPriceRange } from 'common/formatters';

import ButtonDeprecated from 'client/components/ButtonDeprecated';

import withApiState from 'client/helpers/withApiState';

@withApiState({
  updateUserApiState: {
    action: SR_API_ACTION_UPDATE_USER,
  },
})
class SrSwitchToApartmentLowBudget extends Component {
  static propTypes = {
    currentUser: PropTypes.object.isRequired,
    updateUserApiState: PropTypes.object.isRequired,
    onAccept: PropTypes.func.isRequired,
  };

  render() {
    const { currentUser, updateUserApiState, onAccept } = this.props;

    const descriptionText =
      'Unfortunately, there are no stand-alone homes for your budget of ' +
      `${formatPriceRange(currentUser.searchFilters)}, ` +
      'so we removed it from your search filters.';

    return (
      <div className="page-postSignupModal">
        <div className="modal success confirm">
          <div className="contentContainer">
            <div className="heroGrid" />
            <div className="textContainer">
              <span className="headline">
                Wow, there are lots of duplexes & apartments in your budget!
              </span>
              <span className="explainer">{descriptionText}</span>
            </div>

            <ButtonDeprecated onClick={onAccept} disabled={updateUserApiState.inProgress}>
              ok, see rentals
            </ButtonDeprecated>
          </div>
        </div>
      </div>
    );
  }
}

SrSwitchToApartmentLowBudget.displayName = 'SrSwitchToApartmentLowBudget';

export default SrSwitchToApartmentLowBudget;
